<template>
  <div>
    <el-dialog
      class="comn_dialog"
      :title="dialogTitle"
      :visible.sync="visible"
      :width="popupWidth"
      :top="popupTop"
      :modal-append-to-body="modalAppendToBody"
      :close-on-click-modal="closeModel"
      :append-to-body="true"
      :fullscreen="dialogFullScreen"
      @close="Cancel"
    >
      <slot>
        <p>弹窗内容自定义</p>
      </slot>

      <!-- 封装 底部 各种 情况-->
      <slot name="checkTipFlag"></slot>

      <span v-show="showBtn" slot="footer" class="dialog-footer">
        <eui-btn v-if="isShowCancel" type="secondary" @click="Cancel">{{
          cancelButtonTip
        }}</eui-btn>
        <eui-btn v-if="isShowConfirm" v-debounce="Save" type="primary">{{ buttonTip }}</eui-btn>
        <div v-show="showTip" class="tip-wrap">
          提交后，可在规格申请菜单查询审核进度，审核通过后才可使用。
        </div>
      </span>
      <span v-show="showCloseBtn" slot="footer" class="dialog-footer">
        <eui-btn type="secondary" @click="Cancel">关闭</eui-btn>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  props: {
    dialogTitle: {
      type: String,
      default: '标题',
    },
    centerDialogVisible: {
      type: Boolean,
      default() {
        return false;
      },
    },
    popupWidth: {
      type: String,
      default() {
        return '430px';
      },
    },
    popupTop: {
      type: String,
      default() {
        return '23vh';
      },
    },
    showBtn: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showCloseBtn: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showTip: {
      type: Boolean,
      default() {
        return false;
      },
    },
    confirmBtnText: {
      type: String,
      default: '确 定',
    },
    closeModel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    dialogFullScreen: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isShowCancel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isShowConfirm: {
      type: Boolean,
      default() {
        return true;
      },
    },
    buttonTip: {
      type: String,
      default() {
        return '确 定';
      },
    },
    cancelButtonTip: {
      type: String,
      default() {
        return '取 消';
      },
    },
    modalAppendToBody: {
      /* 控制是否将弹框插入至 body 元素中。嵌套的表格如果插入至 body 元素中，将不会被遮挡 */
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    visible: {
      get() {
        return this.centerDialogVisible;
      },
      set(val) {
        // 当visible改变的时候，触发父组件的 updateVisible方法，在该方法中更改传入子组件的 centerDialogVisible的值
        this.$emit('updateVisible', val);
      },
    },
  },
  methods: {
    Cancel() {
      this.$emit('resetPopupData');
    },
    Save: _.debounce(function () {
      this.$emit('submitPopupData');
    }, 500),
  },
};
</script>
<style lang="scss">
.comn_dialog {
  // .el-dialog__header {
  //   padding: 13px 10px;
  //   border-bottom: 1px solid #EDEDED;
  //   // box-shadow: 0px 4px 4px -4px #d1d0d0;
  //   background: #F5F5F5;
  // }
  // .el-dialog__title {
  //   font-size: 16px;
  //   letter-spacing: 1px;
  //   color: #464646;
  //   font-weight: bolder;
  // }
  .el-dialog__footer {
    padding: 20px 20px 20px 0px;
    text-align: center;
  }
  // .el-dialog__headerbtn {
  //   position: static; // 兼容IE11 ,取消原有的position定位
  // }
  // .el-dialog__close {
  //   // color: $header_bg;
  //   font-size: 20px;
  //   font-weight: bolder;
  //   position: absolute;
  //   top: 16px;
  //   right: 8px;
  //   &::after {
  //     content: '';
  //   //   border: 2px solid $header_bg;
  //     width: 20px;
  //     height: 20px;
  //     border-radius: 25px;
  //     position: absolute;
  //     right: -2px;
  //     top: -3px;
  //   }
  // }
  .el-dialog__body {
    padding: 20px;
  }
  .tip-wrap {
    color: #999;
    font-size: 14px;
    margin-top: 20px;
  }
}
</style>
